import { AnnotationTag } from "src/services/api/api.types"

/**
 * The user rating options for the feedback modal.
 */
export enum FeedbackRating {
  THUMBS_UP = "thumbs_up",
  THUMBS_DOWN = "thumbs_down",
}

export interface FeedbackGroup {
  name: string
  rating: FeedbackRating
  tags: AnnotationTag[]
}

export const FEEDBACK_GROUPS_TAG_NAMES: {
  name: string
  rating: FeedbackRating
  tagNames: string[]
}[] = [
  {
    name: "positive",
    rating: FeedbackRating.THUMBS_UP,
    tagNames: ["clarity", "helpfulness", "accuracy", "tone", "efficiency", "depth", "other"],
  },
  {
    name: "negative",
    rating: FeedbackRating.THUMBS_DOWN,
    tagNames: ["inaccurate", "unclear", "unsafe", "bad output", "other"],
  },
]
